export default "__VITE_ASSET__D3L0Vjx1__"